import { ModalEditAppointment } from "./modalEditAppointment.js";
import {ModalTiteledWindow} from "./modalWindow.js";
import { ModalConfirm } from "./modalConfirm.js";

export class ModalShowAppointment extends ModalTiteledWindow {

   constructor(app, appointment, classes, dm) {
      super();
      this.app = app;
      this.addClass('show-appointment');
      this.buildHTML(appointment, classes, dm);
   }

   async buildHTML(app, classes, dm) {
      let meta = `Erstellt von ${(await dm.getUser(app.creator)).lastName} am ${new Date(app.creationTime*1000).format('%d.%m.%Y um %H:%i:%s Uhr')}`;

      const note = await this.getNote(app, 'note');
      const noteSens = await this.getNote(app, 'noteSens');
      const notePublic = await this.getNote(app, 'notePublic');

      let html = `
         <div class="modal-show-appointment">
            <div class="meta" style="background-color: #8bacff; font-size: .8rem; padding: 0 .5rem">${meta}</div>
            <div class="note" style="padding: 0 .5rem">${note}</div>
            <div class="note" style="padding: 0 .5rem">${noteSens}</div>
            <div class="note" style="padding: 0 .5rem">${notePublic}</div>
            <div class="space"></div>
            <div class="buttons bottom-bar">
               <i class="btn-delete icon-trash button-circle"></i>
               <i class="btn-edit icon-edit button-circle"></i>
            </div>
         </div>`;

      await dm.getUser(app.creator);
      if (app.lastModTime !== app.creationTime) meta += `<br>zuletzt geändert von ${(await dm.getUser(app.lastModifier)).lastName} am ${new Date(app.lastModTime*1000).format('%d.%m.%Y um %H:%i:%s Uhr')}`;

      this.setTitle(`<span class="classes">${classes}</span><span class="app-title">${app.title}</span> (${Date.simplifyDatePeriod(app.dateFrom, app.dateTo)})`);
      this.setBody(html);

      const elBtnEdit = this.panel.querySelector('.btn-edit');
      const elBtnDelete = this.panel.querySelector('.btn-delete');

      if (app.editable) elBtnEdit.onclick = () => this.onEdit(app);
      else elBtnEdit.classList.add('disabled');

      if (app.deletable) elBtnDelete.onclick = () => this.onDelete(app);
      else elBtnDelete.classList.add('disabled');



      setTimeout(() => this.show(), 1);

   }

   onEdit(appointment) {
      new ModalEditAppointment(this.app, appointment);
      this.close();
   }


   onDelete(appointment) {

      new ModalConfirm(
         "Soll dieser Termin wirklich gelöscht werden?",
         async (confirmed) => {
            if (confirmed) {
               await this.app.dm.sinRequest({action: 'app-delete', id: appointment.id});
               const data = await this.app.dm.getSyncData(false, true);
               if (data) await this.app.dm.synchronize(data, true);
               this.app.cal.load(true);
               this.close();
            }
         }
      );

   }

   async getNote(app, noteName) {
      if (app[noteName] === false) {
         if (this.app.dm.online) {
            app = await this.reloadAppointment(app);
            return app[noteName];
         }
         else {
            return "[ Diese Information kann nur angezeigt werden, wenn eine Internetverbindung besteht. ]";
         }
      }
      else {
         return app[noteName];
      }
   }

   async reloadAppointment(app) {
      const resp = await this.app.dm.sinRequest({action: 'app-get-by-id', 'appId': app.id});
      if (resp.data) return resp.data;
      else {
         toast.alert("Der Termin mit der ID " + app.id + " konnte nicht geladen werden.", { duration: 8000 });
         logger.error("Der Termin mit der ID " + app.id + " konnte nicht geladen werden.");
         return app;
      }
   }

}
